import React, { useEffect, useState } from 'react';
import { Form, Select, Collapse, Input, Tooltip, InputNumber, Switch, Checkbox } from 'antd';
import { createUseStyles } from 'react-jss'

import Collection from '../../../common/Collection'

import CRUDE_VidiUslugNaMeropriyatii from '../../../objects/VidiUslugNaMeropriyatii/crude'

import CRUDE_TipiTarifov from '../../../objects/TipiTarifov/crude'

import CRUDE_StatusiPokupatelya from '../../../objects/StatusiPokupatelya/crude'

import { POST, errorCatch, deleteInArray, updateInArray, GET } from 'fennec-ui'
import NovieUslugiKlientu from '../NovieUslugiKlientu';
import IzmenitUslugiKlientu from '../IzmenitUslugiKlientu';
import NovieTarifi from '../NovieTarifi';
import IzmenitTarifi from '../IzmenitTarifi';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { Action } from 'fennec-ui';
import { IfElse } from '../../../common/Rule';
import EmojiTextArea from '../../../common/EmojiTextArea';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Panel } = Collapse;

const { Option } = Select;

const useStyles = createUseStyles({
    tabs: {
        '& .ant-tabs-nav': {
            margin: "0 0 6px 0"
        },
        '& .ant-tabs-tab + .ant-tabs-tab': {
            margin: "0 0 0 20px"
        },
        '& .ant-tabs-nav .ant-tabs-tab': {
            padding: "5px 0",
            fontSize: "13px"
        }
    },
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-2px",
            left: "9px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "25px",
            fontWeight: "300"
        },
        '&.ant-collapse .filtered .filtered-header-wrapper .ant-card-body': {
            padding: "7px",
        }
    },
    fieldName: {
        fontWeight: "300"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300"
    },
    pricetableColumn: {
        '.ant-table-thead > tr > th&': {
            fontSize: "12px",
            textAlign: "right",
        },
        'td&': {
            fontSize: "12px",
            color: "#8d8d8d",
            textAlign: "right",
        }
    },
    lower: {
        color: "red"
    },
    grater: {
        color: "blue"
    }
})

export default function IzmenitUslugiNaMeropriyatii(props) {
    const classes = useStyles()
    const { auth, object, form, sourceKey, soruceID, orgID, queryFilterContext } = props;

    const [uslugi, setUslugi] = useState([]);
    const [tarifi, setTarifi] = useState([]);
    const [pricetable, setPriceTable] = useState({});
    const setTarifiSorted = (value) => {
        let x = [...value];
        if (object.tipTarifaID == 1) {
            //Сортировка тарифов по возрастанию даты окончания
            x.sort((a, b) => {
                return dayjs(a.dataVremyaOkonchaniya).isBefore(dayjs(b.dataVremyaOkonchaniya));
            })
        } else if (object.tipTarifaID == 2) {
            //Сортировка тарифов по количеству
            x.sort((a, b) => {
                return a.kolichestvoDo - b.kolichestvoDo
            })
        }

        setTarifi(x);
    }
    useEffect(() => {
        GET(auth, "/api/uslugiklientu/byuls/" + object.ID,
            ({ data }) => setUslugi(data),
            () => errorCatch
        );
        GET(auth, "/api/tarifi/byuls/" + object.ID,
            ({ data }) => setTarifiSorted(data),
            () => errorCatch
        );
    }, [object]);
    useEffect(() => {
        GET(auth, "/api/usluginameropriyatii/pricetable/" + object.ID,
            ({ data }) => setPriceTable(data),
            () => errorCatch
        );
    }, [object, uslugi, tarifi]);

    // const vidiUslugNaMeropriyatii = useSelector(REDUX_VidiUslugNaMeropriyatii.selector.arrayByKey(sourceKey));
    // const tipiTarifov = useSelector(REDUX_TipiTarifov.selector.arrayByKey(sourceKey));
    // const statusiPokupatelya = useSelector(REDUX_StatusiPokupatelya.selector.arrayByKey(sourceKey));
    const [vidiUslugNaMeropriyatii, setVidiUslugNaMeropriyatii] = useState([]);
    const [tipiTarifov, setTipiTarifov] = useState([]);
    const [statusiPokupatelya, setStatusiPokupatelya] = useState([]);

    useEffect(() => {
        form.resetFields();
        CRUDE_VidiUslugNaMeropriyatii.read(auth, (data) => {
            if (data.length > 0) {
                // dispatch(REDUX_VidiUslugNaMeropriyatii.actions.setArrayByKey(sourceKey, data));
                setVidiUslugNaMeropriyatii(data)
            }
        }, 'model', 's-id=ASC');

        CRUDE_TipiTarifov.read(auth, (data) => {
            if (data.length > 0) {
                // dispatch(REDUX_TipiTarifov.actions.setArrayByKey(sourceKey, data));
                setTipiTarifov(data)
            }
        }, 'model', 's-id=ASC');

        CRUDE_StatusiPokupatelya.read(auth, (data) => {
            if (data.length > 0) {
                // dispatch(REDUX_StatusiPokupatelya.actions.setArrayByKey(sourceKey, data));
                setStatusiPokupatelya(data)
            }
        }, 'model', 's-id=ASC');
    }, []);

    const vidiUslugNaMeropriyatiiOptions = vidiUslugNaMeropriyatii.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const tipiTarifovOptions = tipiTarifov.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{ ...object }}
            >
                <Form.Item label="Название услуги"
                    name="nazvanie"
                    rules={[{ required: true, message: 'Пожалуйста, укажите название!' }]}
                >
                    <Input />
                </Form.Item>
                <div style={{ marginTop: "20px" }}>
                    <Form.Item label="Описание услуги (располагается выше сетки цен)"
                        tooltip="На странице мероприятия в блоке услуги это описание располагается выше сетки цен."
                        name="opisanie"
                        rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                    >
                        <EmojiTextArea rows={8} />
                    </Form.Item>
                </div>
                <div style={{ marginTop: "10px" }}>
                    <Form.Item label="Описание услуги (располагается ниже сетки цен)"
                        tooltip="На странице мероприятия в блоке услуги это описание располагается ниже сетки цен."
                        name="priceText"
                        rules={[{ required: false, message: 'Пожалуйста, укажите описание услуги!' }]}
                    >
                        <EmojiTextArea rows={8} />
                    </Form.Item>
                </div>
                <Form.Item label="Вид услуги"
                    name="vidUslugiID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите вид услуги!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {vidiUslugNaMeropriyatiiOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Тип тарифа"
                    name="tipTarifaID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите tип тарифа!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {tipiTarifovOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"sort"}
                    label={"Порядок сортировки"}
                    rules={[{ required: false, message: 'Укажите необходимый кворум!' }]}
                >
                    <InputNumber precision={0} style={{ width: "150px" }} />
                </Form.Item>
                <Form.Item
                    name="vklyuchitKommentarii"
                    valuePropName="checked"
                >
                    <Checkbox>
                        Включить комментарий покупателя
                    </Checkbox>
                </Form.Item>
                {/* <Form.Item label="Статус покупателя"
                    name="statusPokupatelyaID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите статус покупателя!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {statusiPokupatelyaOptions}
                    </Select>
                </Form.Item> */}
            </Form>
            <Collapse className={classes.collapse} accordion>
                <Panel header="Позиции, из которых состоит данная услуга" key="service">
                    <Collection
                        auth={auth}
                        noPrint={true}
                        noPagination={true}
                        size="small"
                        // source={"/api/uslugiklientu/byuls/" + object.ID}
                        data={uslugi}
                        ordering={{
                            field: "sort",
                            action: {
                                method: "POST",
                                path: "/api/uslugiklientu/sort",
                                mutation: "upgrade",
                                onDispatch: () => (arr) => setUslugi(arr),
                            }
                        }}
                        columns={() => {
                            let c = [
                                {
                                    title: 'Название позиции',
                                    fixed: 'left',
                                    width: 120,
                                    render: (text, record) => {
                                        return (record?.yacheikaUsluga?.nazvanie);
                                    }
                                },
                                {
                                    title: 'Кол-во',
                                    render: (text, record) => {
                                        return (record.kolichestvo);
                                    }
                                },
                                {
                                    title: 'Процент',
                                    render: (text, record) => {
                                        return (record.protsentObshcheiSummiUslugiNaMeropriyatii);
                                    }
                                },
                                {
                                    title: <div style={{ width: "100%", textAlign: "end" }}>{'Сумма'}</div>,
                                    render: (text, record) => {
                                        return <div style={{ width: "100%", textAlign: "end" }}>{Number((record.rubleiOtObshcheiSummiUslugiNaMeropriyatii).toFixed(2)).toLocaleString('ru', { useGrouping: true, minimumFractionDigits: 2 })} руб.</div>;
                                    }
                                }
                            ];
                            tarifi.forEach(tarif => {
                                c.push({
                                    className: classes.pricetableColumn,
                                    // title: (
                                    //     <Action
                                    //         key={tarif.ID}
                                    //         auth={auth}
                                    //         mode={"text"}
                                    //         object={tarif}
                                    //         title={dayjs(tarif.dataVremyaOkonchaniya).format("MMM DD")}
                                    //         collection={tarifi}
                                    //         setCollection={setTarifiSorted}
                                    //         action={(values, unlock, close, { collection, setCollection }) => {
                                    //             POST(auth, '/api/tarifi/delete', { ...tarif },
                                    //                 () => setTarifiSorted(deleteInArray(tarifi, tarif)), errorCatch
                                    //             );
                                    //         }}
                                    //     />
                                    // ),
                                    title: IfElse(object.tipTarifaID == 1,
                                        dayjs(tarif.dataVremyaOkonchaniya).format("DD MMM"),
                                        <span><span>до </span>{tarif.kolichestvoDo}</span>),
                                    children: [
                                        {
                                            className: classes.pricetableColumn,
                                            title: (
                                                <Action
                                                    key={tarif.ID}
                                                    auth={auth}
                                                    mode={"link"}
                                                    object={tarif}

                                                    title={tarif.summa}
                                                    modal={{
                                                        minWidth: "300px",
                                                        title: "Изменить тариф",
                                                    }}
                                                    collection={tarifi}
                                                    setCollection={setTarifiSorted}
                                                    action={{
                                                        method: "POST",
                                                        path: "/api/tarifi/update",
                                                        mutation: (array, item) => {
                                                            return updateInArray(array, item).sort((a, b) => dayjs(a.dataVremyaOkonchaniya).unix() - dayjs(b.dataVremyaOkonchaniya).unix())
                                                        },
                                                        onValues: (values) => {
                                                            return { ...values, ID: tarif.ID }
                                                        },
                                                        onClose: ({ close }) => close(),
                                                    }}
                                                    form={IzmenitTarifi}
                                                    context={object}
                                                    sourceKey={sourceKey}
                                                    soruceID={soruceID}
                                                    queryFilterContext={queryFilterContext}
                                                />
                                            ),
                                            // title: <div style={{cursor: "pointer"}} onClick={()=>{console.log(tarif.summa);}}>{tarif.summa}</div>,
                                            render: (text, record) => {
                                                if (pricetable && pricetable[record.ID] && pricetable[record.ID][tarif.ID]) {
                                                    let v = pricetable[record.ID][tarif.ID];
                                                    if (v.grater) {
                                                        return <Tooltip title={"Больше на: " + v.dif + " руб."}><span className={classes.grater}>{v.price}</span></Tooltip>;
                                                    } else if (v.lower) {
                                                        return <Tooltip title={"Меньше на: " + v.dif + " руб."}><span className={classes.lower}>{v.price}</span></Tooltip>;
                                                    } else {
                                                        return <span>{v.price}</span>;
                                                    }
                                                }
                                                return "";
                                            },
                                        }
                                    ]
                                });
                            });
                            return c;
                        }}
                        collectionActions={() => [
                            {
                                action: {
                                    method: "POST",
                                    path: "/api/uslugiklientu/new",
                                    mutation: (array, item) => {
                                        return updateInArray(array, { ...item, sort: (array.length) ? array[array.length - 1].sort + 1 : 0 }).sort((a, b) => dayjs(a.sort).unix() - dayjs(b.sort).unix())
                                    },
                                    onValues: (values, context) => {
                                        return {
                                            ...values, uslugaNaMeropriyatiiID: object.ID,
                                            sort: (context && context.collection && context.collection.length) ? context.collection[context.collection.length - 1].sort + 1 : 0
                                        }
                                    },
                                    onClose: ({ close }) => close(),
                                    onDispatch: () => (arr) => setUslugi(arr),
                                },
                                title: "Добавить позицию",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Добавление позиции в услугу",
                                },
                                form: NovieUslugiKlientu,
                                sourceKey: sourceKey,
                                soruceID: soruceID,
                                orgID: orgID,
                                queryFilterContext: queryFilterContext
                            }
                        ]}
                        modelActions={(item) => [
                            {
                                title: "Изменить",
                                modal: {
                                    width: "50%",
                                    minWidth: "500px",
                                    title: "Изменение позиции в услуге",
                                },
                                action: {
                                    method: "POST",
                                    path: "/api/uslugiklientu/update",
                                    mutation: "update",
                                    onValues: (values) => {
                                        return { ...values, ID: item.ID, uslugaNaMeropriyatiiID: object.ID }
                                    },
                                    onClose: ({ close }) => close(),
                                    onDispatch: () => (arr) => setUslugi(arr),
                                },
                                form: IzmenitUslugiKlientu,
                                sourceKey: sourceKey,
                                soruceID: soruceID,
                                queryFilterContext: queryFilterContext,
                            },
                            {
                                title: "Удалить",
                                action: (values, unlock, close) => {
                                    POST(auth, '/api/uslugiklientu/delete', { ...item },
                                        () => setUslugi(deleteInArray(uslugi, item)), errorCatch
                                    );
                                },
                            }
                        ]}
                    />
                </Panel>
                <Panel header="Тарифы" key="tarifi">
                    <Collection
                        auth={auth}
                        noPrint={true}
                        noPagination={false}
                        size="small"
                        // source={"/api/tarifi/byuls/" + object.ID}
                        data={tarifi}
                        columns={() => [
                            IfElse(object.tipTarifaID == 1,
                                {
                                    title: 'Окончание действия тарифа',
                                    render: (text, record) => {
                                        return (dayjs(record.dataVremyaOkonchaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm'));
                                    }
                                },
                                {
                                    title: 'Количество проданных до',
                                    render: (text, record) => {
                                        return (record.kolichestvoDo);
                                    }
                                }
                            ),
                            {
                                title: <div style={{ width: "100%", textAlign: "end" }}>{'Сумма'}</div>,
                                render: (text, record) => {
                                    return <div style={{ width: "100%", textAlign: "end" }}>{Number((record.summa).toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.</div>;
                                }
                            }
                        ]}
                        collectionActions={() => [
                            {
                                action: {
                                    method: "POST",
                                    path: "/api/tarifi/new",
                                    mutation: (array, item) => {
                                        return updateInArray(array, item).sort((a, b) => dayjs(a.dataVremyaOkonchaniya).unix() - dayjs(b.dataVremyaOkonchaniya).unix())
                                    },
                                    onValues: (values) => {
                                        return { ...values, uslugaNaMeropriyatiiID: object.ID }
                                    },
                                    onClose: ({ close }) => close(),
                                    onDispatch: () => (arr) => setTarifiSorted(arr),
                                },
                                title: "Новый тариф",
                                modal: {
                                    width: "40%",
                                    minWidth: "400px",
                                    title: "Новый тариф",
                                },
                                form: NovieTarifi,
                                context: object,
                                sourceKey: sourceKey,
                                soruceID: soruceID,
                                queryFilterContext: queryFilterContext
                            },
                            {
                                action: (values, unlock, close) => {
                                    GET(auth, "/api/tarifi/newfromtemplate/" + object.ID,
                                        ({ data }) => {
                                            setTarifiSorted(data)
                                        }, errorCatch
                                    );
                                },
                                title: "Заполнить из шаблона",
                            }
                        ]}
                        modelActions={(item) => [
                            {
                                title: "Изменить",
                                modal: {
                                    minWidth: "300px",
                                    title: "Изменить тариф",
                                },
                                action: {
                                    method: "POST",
                                    path: "/api/tarifi/update",
                                    mutation: (array, item) => {
                                        return updateInArray(array, item).sort((a, b) => dayjs(a.dataVremyaOkonchaniya).unix() - dayjs(b.dataVremyaOkonchaniya).unix())
                                    },
                                    onValues: (values) => {
                                        return { ...values, ID: item.ID }
                                    },
                                    onClose: ({ close }) => close(),
                                    onDispatch: () => (arr) => setTarifiSorted(arr),
                                },
                                form: IzmenitTarifi,
                                context: object,
                                sourceKey: sourceKey,
                                soruceID: soruceID,
                                queryFilterContext: queryFilterContext,
                            },
                            {
                                title: "Удалить",
                                action: (values, unlock, close) => {
                                    POST(auth, '/api/tarifi/delete', { ...item },
                                        () => setTarifiSorted(deleteInArray(tarifi, item)), errorCatch
                                    );
                                },
                            }
                        ]}
                    />
                </Panel>
            </Collapse>
        </>
    );
}
